export const STEP_TITLES = {
  DETAILS: 'Details',
  REVIEW_AND_SIGN: 'Review/Sign',
}

export const STEP_IDS = {
  DETAILS: 1,
  REVIEW_AND_SIGN: 2,
} as const

export const FILLABLE_PDFS_STEPS = [
  {
    id: STEP_IDS.DETAILS,
    title: STEP_TITLES.DETAILS,
  },
  {
    id: STEP_IDS.REVIEW_AND_SIGN,
    title: STEP_TITLES.REVIEW_AND_SIGN,
  },
]
